import type { FleetFilter } from '../../../../../hooks/useFleet'
import type { FleetSummary } from '../../../../../types'

export function fleetFilterCount(summary: FleetSummary | null | undefined, filter: FleetFilter) {
  if (!summary) return undefined

  const {
    totalCount,
    activeCount,
    closedCount,
    orderedCount,
    expiringCount,
    unresolvedCount,
    overMileageCount,
    administratedCount,
  } = summary

  switch (filter) {
    case 'order':
      return orderedCount
    case 'active':
      return activeCount
    case 'administrated':
      return administratedCount
    case 'expiring':
      return expiringCount
    case 'closed':
      return closedCount
    case 'unresolved':
      return unresolvedCount
    case 'overmileage':
      return overMileageCount
    default:
      return totalCount
  }
}
